up.compiler("[data-redirect]", element => {
  setTimeout(() => {
    window.location.href = element.dataset.redirect
  }, 1500)
})